import { Col, Row } from "antd";
import React from "react";
import PropTypes from "prop-types";
import formatter from './../../../../../../utils/formatter';
import Heading from "../../../RecommendGrant/Component/ViewEditSchedules/Components/Heading";
import InfoBlock from "../../../RecommendGrant/Component/ViewEditSchedules/Components/InfoBlock";
import { BoxDetailWrapper } from "../../styles";

export const getRadioComponentData = (value) => {
  switch(value){
    case true: return "Yes";
    case false: return "No";
    default: return <>&mdash;</>;
  }
} 

const paymentComponent = (data, index) => {
  const {
    paymentAmount,
    isPaymentContingent,
    intendedPaymentDate,
    requirementType,
    isReportingRequired,
    requirementDueDate
  } = data;

  return (
    <>
      <Row type="flex">
        <BoxDetailWrapper border span={24}>
          <InfoBlock value={`Payment ${index + 1}`} />
        </BoxDetailWrapper>
      </Row>
      <Row type="flex">
        <BoxDetailWrapper border span={24}>
          <Col span={11}>
            <InfoBlock title="Grant Amount" value={paymentAmount ? `${formatter({ value: paymentAmount, fieldSuffix: "Dollars" })}` : <>&mdash;</>} />
          </Col>
          <Col span={11} offset={1}>
            <InfoBlock
              title="Intended Payment Date"
              value={intendedPaymentDate ? intendedPaymentDate : <>&mdash;</>}
            />
          </Col>
        </BoxDetailWrapper>
      </Row>

      <Row type="flex">
        <BoxDetailWrapper border span={24}>
          <Col span={11}>
            <InfoBlock
              title="Reporting Requirement"
              value={getRadioComponentData(isReportingRequired)}
            />
          </Col>
          <Col span={11} offset={1}>
            <InfoBlock title="Requirement Type" value={requirementType ? requirementType : <>&mdash;</>} />
          </Col>
        </BoxDetailWrapper>
      </Row>
      <Row type="flex">
        <BoxDetailWrapper span={24}>
          <Col span={11}>
            <InfoBlock
              title="Requirement Due Date"
              value={requirementDueDate ?  requirementDueDate : <>&mdash;</>}
            />
          </Col>
          <Col span={11} offset={1}>
            <InfoBlock
              title="Is payment contingent?"
              value={getRadioComponentData(isPaymentContingent)}
            />
          </Col>
        </BoxDetailWrapper>
      </Row>
    </>
  );
};


/**
 * Components layout is complicated because of the design requirements
 *
 */
export default function Step3Summary({ title, payments = [], edit = false, handleEdit }) {

  return (
    <>
      <Heading title={title} edit={edit} handleEdit={handleEdit} />
      <Row type="flex" gutter={24} justify={'start'}>
          {payments.map((each, index) => (
            <Col lg={11} span={23} key={each.paymentAmount + each.intendedPaymentDate}>{paymentComponent(each, index)}</Col>
          ))}
      </Row>
    </>
  );
}

Step3Summary.propTypes = {
  edit: PropTypes.bool,
  handleEdit: PropTypes.any,
  payments: PropTypes.array,
  title: PropTypes.any
}
